import GoExternalGameBase from '#BASE/components/externalGame/externalGame.go.component';
import * as gameMenu from 'BASE/common/menu/menu.game';
import { GameTag, getGameTag, getVRGameTag } from 'BASE/common/gameTag';

export default {
    name: 'LotteryMenu',
    mixins: [GoExternalGameBase],
    data() {
        return {
            gameTag: GameTag,
            gameMenus: {},            
            vrMenus: [],            
            vrPrefix: 'VR_',
        };
    },
    computed: {
        gameDatas() {
            return this.$store.state.lottoinfo.data;
        },
        LotteryMenu() {
            if (!this.gameMenus.homeLeft || this.gameMenus.homeLeft.Items.length <= 0)
                return [];

            let leftMenu = gameMenu.mergeInfo(this.gameMenus.homeLeft, [this.gameDatas]);
            if (Object.keys(leftMenu).length !== 0) {
                leftMenu.forEach(category => {
                    category.Items.forEach(game => {
                        game.Tag = getGameTag(game.LotteryGameHotNewState);
                    });
                });
            }
            return leftMenu;
        },
        VrMenu() {
            if (Object.keys(this.vrMenus).length <= 0)
                return [];

            let vrItems = JSON.parse(JSON.stringify(this.vrMenus));
            for (let game of vrItems) {
                game.Tag = getVRGameTag(this.vrPrefix + game.GameCode);
            }
            return vrItems;
        },
    },
    methods: {
        mergeInfo(collected, objs) {
            let res = [];
            let _this = this;
            if (!collected || objs.some(o => !o)) {
                return res;
            }

            for (let _gameId of collected) {
                let infos = {};
                infos = objs.map(o => o[_gameId]);
                if (infos.every(i => i)) {
                    res.push(Object.assign({ Id: _gameId }, ...infos));
                }
            }
            return res;
        },
    },    
    async mounted() {
        let _this = this;
        const gameMenus = gameMenu.get();
        const vrMenus = this.getVRLottery();   // 取得VR彩票

        gameMenus.then(r => _this.gameMenus = r);
        vrMenus.then(r => _this.vrMenus = r);

        await Promise.all([gameMenus, vrMenus]);
    },
}